class Beca{
    constructor(
        public idalum: number = 0,
        public idclas: string = "",
        public idcent: string = "",
        public nom_alumne: string = "",
        public serveis: number = 0,
        public menbec1: number = 0.00,
        public menbec2: number = 0.00,
        public import_bea: string = "",
        public import_AMB: string = "",
        public import_ajunt: string = "",
    ){}
}
export default Beca;